module.exports = __webpack_public_path__ + "media/react/assets/OtherInfoCard-3502c3ff9343bb9fd039609c8b3c327a.svg";